import { FontAwesomeIcon } from '@appcharge/shared-ui';

const InfoBanner: React.FC<{ onClose: () => void }> = ({ onClose }) => {
    return (
        <div className="flex items-center justify-between gap-4 mb-4 rounded-t-md border border-sky-50 bg-sky-50 px-3 py-[11px]">
            <div className="flex items-center gap-2">
                <FontAwesomeIcon
                    icon="fa-regular fa-circle-info"
                    className="text-base-sidebarForeground text-lg"
                />
                <div className="flex items-center gap-2 text-sm text-gray-700">
                    <span className="font-semibold">Information</span>
                    <span className="text-base-sidebarForeground">|</span>
                    <span>The <b>finalized</b> financial data will be uploaded to the Payouts section after the end of each month</span>
                </div>
            </div>
            <button
                onClick={onClose}
                className="text-base-sidebarForeground hover:opacity-70 transition-opacity"
                aria-label="Close information banner"
            >
                <FontAwesomeIcon
                    icon="fa-regular fa-xmark"
                    className="text-lg"
                />
            </button>
        </div>
    );
};

export default InfoBanner;

